import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import EstateMpProvider from "@/core/data-provider/data-mp/estate/estate-mp-provider";
import GameMpProvider from "@/core/data-provider/data-mp/game/game-mp-provider";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import toast from "@/domains/toasts/helpers/toast";

export default function useGetIntercom(estateId, setIsLockedRoom) {
  const { t } = useTranslation("hotel");

  const [isLoading, setIsLoading] = useState(false);
  const [roomData, setRoomData] = useState(null);

  const onClose = useCallback(() => {
    setRoomData(null);
    GameMpProvider.closeCurrentInterface(true);
  }, []);

  const load = useCallback(async () => {
    setIsLoading(true);

    try {
      const roomResponse = await EstateMpProvider.getHotelRoomDetailsByEstateId(estateId);

      if (roomResponse instanceof RpcMpProviderFailedResponse) {
        console.error(roomResponse);
        toast.error(t("hotel.toast.loadingRoomError"));
        onClose();
      } else if (roomResponse?.data && Object.keys(roomResponse.data).length > 0) {
        setRoomData(roomResponse.data);
        setIsLockedRoom(roomResponse.data.isLocked);
      }
    } catch (e) {
      console.error(e);
      toast.error(t("hotel.toast.loadingSystemError"));
      onClose();
    } finally {
      setIsLoading(false);
    }
  }, [estateId, onClose, setIsLockedRoom, t]);

  useEffect(() => {
    load();
  }, [load]);

  return { roomData, isLoading, onClose, load };
}
